import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ContentChecklistState')
export class ContentChecklistState {
  public static create(contentChecklistState: ContentChecklistState) {
    return Object.assign(new ContentChecklistState(), contentChecklistState);
  }

  @JsonProperty('contentItemStates', [Boolean])
  // @ts-expect-error TS2322 - strict migration
  contentItemStates: [boolean] = undefined;
  @JsonProperty('legalItemStates', [Boolean])
  // @ts-expect-error TS2322 - strict migration
  legalItemStates: [boolean] = undefined;
  @JsonProperty('workflowId', Number)
  // @ts-expect-error TS2322 - strict migration
  workflowId: number = undefined;
}
